import {
  Component,
  Input,
  OnInit,
  NgModule,
  ContentChild,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIGridComponent } from './yzt-grid.component';
export class CustomTemplateComponent {

   customTemplate: TemplateRef<any>;
   outField = '';
   uiGrid: UIGridComponent;
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }
/**
 * @param {?} simple
 * @return {?}
 */
ngOnChanges(simple) {
    if(this.uiGrid && simple['outField']) {
      this.uiGrid.getCusTmplInstance(this);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'custom-template',
  template: `
    <ng-container></ng-container>
  `,
  styles: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'customTemplate': [{ type: ContentChild, args: ['customTemplate', ] },],
'outField': [{ type: Input },],
'uiGrid': [{ type: Input, args: ['ui_grid', ] },],
};
}

function CustomTemplateComponent_tsickle_Closure_declarations() {
/** @type {?} */
CustomTemplateComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CustomTemplateComponent.ctorParameters;
/** @type {?} */
CustomTemplateComponent.propDecorators;
/** @type {?} */
CustomTemplateComponent.prototype.customTemplate;
/** @type {?} */
CustomTemplateComponent.prototype.outField;
/** @type {?} */
CustomTemplateComponent.prototype.uiGrid;
}

export class CustomTemplateModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    CustomTemplateComponent
  ],
  exports: [CustomTemplateComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CustomTemplateModule_tsickle_Closure_declarations() {
/** @type {?} */
CustomTemplateModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CustomTemplateModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
